import styled from "styled-components";

export const Line = styled.line`
    stroke: black;
    stroke-width: 3px;
`;

export const Circle = styled.circle`
    fill: black;
`;
